window.Cart = {};

Cart.init = function () {
  Cart.loadMiniCart();
  Cart.minicartTimeout = null;
  $('.header__topbar .minicart > a').hover(function () {
    clearTimeout(Cart.minicartTimeout);
    MiniCart.onMouseEnter(function () {
      clearTimeout(Cart.minicartTimeout);
    });
    MiniCart.onMouseOut(function () {
      Cart.minicartTimeout = setTimeout(function () {
        MiniCart.hide();
      }, 2000);
    });
    MiniCart.show();
  }, function () {
    Cart.minicartTimeout = setTimeout(function () {
      MiniCart.hide();
    }, 1000);
  });
};

Cart.updateItemsQtyLabel = function (number) {
  var span = $('.minicart .icon-cart span');
  if (number === 0) {
    span.remove();
    return;
  }
  if (!span.length) {
    $('.minicart .icon-cart').append("<span></span>");
    span = $('.minicart .icon-cart span');
  }
  span.html(number);
};

Cart.loadMiniCart = function () {
  return jQuery.ajax({
    url: "/cart/fetch",
    method: "get",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      Cart.updateItemsQtyLabel(resp.itemsQty);
      MiniCart.update(resp.minicartPartial);
    }
  });
};

Cart.addItems = function (items, options, cb) {
  if (typeof options === "function") {
    cb = options;
  } else {
    options = jQuery.extend({updateMinicart: true, showMinicart: true}, options);
  }
  jQuery.ajax({
    url: "/cart/add",
    method: "post",
    data: JSON.stringify(items),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (options.updateMinicart) {
        Cart.loadMiniCart().then(function () {
          if (options.showMinicart) {
            MiniCart.show();
          }
        });
      }
      cb && cb(null, resp);
    },
    error: function (resp) {
      if (resp.status) {
        $('#outOfStockModal').popup('show');
      }
      cb && cb(resp);
    }
  });
};

Cart.removeItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/remove",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.plusItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/increase",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.minusItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/decrease",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.loadItem = function (itemId) {
  return jQuery.ajax({
    url: "/cart/" + itemId + "/item/get",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.updateProduct = function (item) {
  return jQuery.ajax({
    url: "/cart/item/update",
    method: "post",
    data: JSON.stringify(item),
    contentType: 'application/json; charset=utf-8'
  });
};

Cart.clearPromoCode = function () {
  return jQuery.ajax({
    url: "/cart/promocode/clear",
    method: "post",
    contentType: 'application/json; charset=utf-8'
  });
};

var MiniCart = Cart.MiniCart = {};

MiniCart.show = function () {
  $('.minicart_object').show();
};

MiniCart.onMouseEnter = function (cb) {
  $('.minicart_object').unbind("mouseenter").mouseenter(cb);
};

MiniCart.onMouseOut = function (cb) {
  $('.minicart_object').unbind("mouseleave").mouseleave(cb);
};

MiniCart.hide = function () {
  $('.minicart_object').hide();
};

MiniCart.update = function (html) {
  $('.minicart_object').replaceWith(html);
  $('.minicart_object .item .delete > a').each(function (i, link) {
    $(link).click(function (event) {
      event.preventDefault();
      $(link).parent().parent().remove();
      Cart.removeItem(this.id).then(function () {
        Cart.loadMiniCart().then(function () {
          MiniCart.show();
          MiniCart.onMouseOut(function () {
            MiniCart.hide();
          });
        })
      });
    });
  });
};

$(Cart.init);




